import type { UseQueryReturnType } from '@tanstack/vue-query'

export const usePageQuery = <T, E, F extends unknown[]>(query: (...args: F) => UseQueryReturnType<T, E>) => {
  return async (...args: F) => {
    if (import.meta.client) {
      // Client side: suspend page render up to 100ms to avoid skeleton flicker for fast data fetches
      const skeletonDelay = new Promise((resolve) => setTimeout(resolve, 100))

      const queryResult = query(...args)
      const suspense = queryResult.suspense()

      await Promise.race([suspense, skeletonDelay])

      return queryResult
    } else {
      // Server side: wait for query to return data
      const queryResult = query(...args)
      const suspense = queryResult.suspense()

      onServerPrefetch(async () => await suspense)

      return queryResult
    }
  }
}
